import ReactPlayer from "react-player";

import {
  Avatar,
  Box,
  Button,
  Divider,
  ImageList,
  ImageListItem,
  Stack,
  Typography,
} from "@mui/material";

import IntroVideo from "../assets/introVideo/intro.mov";

import SainiAudiobookLogo from "../assets/dkaudiobooks.png";
import DKSaini from "../assets/DKSaini.jpg";
import { Link } from "react-router-dom";

import "./HomePage.css";
import { useEffect, useRef } from "react";

const HomePage = () => {
  // ======================================
  const imageListRef = useRef(null);

  useEffect(() => {
    const prefersReducedMotion =
      typeof window !== "undefined" &&
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    const scrollContainer = imageListRef.current;
    if (!scrollContainer || prefersReducedMotion) {
      return undefined;
    }

    const scrollHeight = scrollContainer.scrollHeight;
    const scrollDuration = 100000; // slower auto-scroll for readability
    const scrollStep = scrollHeight / (scrollDuration / 20);
    let scrollCount = 0;
    const scrollInterval = setInterval(() => {
      if (scrollCount < scrollHeight) {
        scrollContainer.scrollTop += scrollStep;
        scrollCount += scrollStep;
      } else {
        clearInterval(scrollInterval);
      }
    }, 20);

    return () => {
      clearInterval(scrollInterval);
    };
  }, []);
  // ======================================

  const images = importAll(
    require.context("../assets/writers", false, /\.(png|jpe?g|svg)$/)
  );

  function importAll(r) {
    return r.keys().map(r);
  }
  console.log("images");
  return (
    <Box marginTop={4}>
      <Stack
        justifyContent="center"
        alignItems="center"
        gap={{ xs: 2, md: 4 }}
        paddingX={0}
      >
        <Typography
          className="animate-character"
          variant={"h3"}
          fontWeight="bold"
          align="center"
          sx={{
            "@media (max-width: 600px)": {
              fontSize: "2.2rem",
              letterSpacing: 0.5,
            },
            "@media (min-width: 601px) and (max-width: 900px)": {
              fontSize: "3.2rem",
              letterSpacing: 0.5,
            },
            "@media (min-width: 901px)": {
              fontSize: "4.5rem",
              letterSpacing: 0.5,
            },
          }}
        >
          Punjabi Audio Books Library <br /> by <br />
          Devinder Kaur &nbsp; 'D.Saini'
        </Typography>

        <Box sx={{ width: "100%" }}>
          <Divider />
          <Divider />
        </Box>

        <Box
          sx={{
            width: { xs: "100%", md: "80%" },
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 2,
            flexDirection: { xs: "column", md: "row" }, // Stack on small screens, row on medium and above
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 3,
            }}
          >
            <Avatar
              alt="Portrait of Devinder Kaur 'D. Saini'"
              src={DKSaini}
              sx={{
                width: { xs: "10rem", md: 280 },
                height: { xs: "10rem", md: 280 },
                border: "2px solid black",
                boxShadow: "0px 18px 60px rgba(255, 87, 43, 0.5);",
                transition: "box-shadow 0.3s",
                "&:hover": {
                  boxShadow: "0px 18px 60px rgba(255, 87, 43, 2.5);",
                },
              }}
            />
            <Avatar
              alt="Saini Audiobooks logo"
              src={SainiAudiobookLogo}
              sx={{
                width: { xs: "10rem", md: 280 },
                height: { xs: "10rem", md: 280 },
                border: "2px solid black",
                boxShadow: "0px 18px 60px rgba(255, 87, 43, 0.5);",
                transition: "box-shadow 0.3s",
                "&:hover": {
                  boxShadow: "0px 18px 60px rgba(255, 87, 43, 2.5);",
                },
              }}
            />
          </Box>

          <Box
            sx={{
              textAlign: { xs: "center", md: "left" },
              width: "100%",
              display: "flex",
              flexDirection: { xs: "row", md: "column" },
              justifyContent: "space-around",
              alignItems: "center",
            }}
          >
            <Typography
              align="center"
              fontWeight="bold"
              variant="h2"
              gutterBottom
              sx={{
                "@media (max-width: 600px)": { fontSize: "2.2rem" },
                "@media (min-width: 601px) and (max-width: 900px)": {
                  fontSize: "3rem",
                },
                "@media (min-width: 901px)": { fontSize: "3.5rem" },
              }}
            >
              {process.env.REACT_APP_API_AUDIO_COUNT}k+
              <Typography align="center" fontWeight="bold" component="div">
                AUDIOS
              </Typography>
            </Typography>
            <Typography
              align="center"
              fontWeight="bold"
              variant="h2"
              gutterBottom
              sx={{
                "@media (max-width: 600px)": { fontSize: "2.2rem" },
                "@media (min-width: 601px) and (max-width: 900px)": {
                  fontSize: "3rem",
                },
                "@media (min-width: 901px)": { fontSize: "3.5rem" },
              }}
            >
              {process.env.REACT_APP_API_BOOK_COUNT}+
              <Typography align="center" fontWeight="bold" component="div">
                BOOKS
              </Typography>
            </Typography>
          </Box>
        </Box>

        <Box sx={{ width: "100%" }}>
          <Divider />
          <Divider />
        </Box>

        <Box sx={{ display: "flex", gap: 2, marginBottom: "1rem" }}>
          <Button
            size="large"
            variant="contained"
            color="warning"
            sx={{
              px: 4,
              py: 1.75,
              fontSize: "1.15rem",
              fontWeight: 700,
              letterSpacing: 0.5,
              borderRadius: 9999,
              background: "linear-gradient(90deg, #ff4b2b 0%, #ff416c 100%)",
              boxShadow:
                "0 6px 18px rgba(255,65,108,0.35), 0 2px 6px rgba(0,0,0,0.1)",
              textTransform: "none",
              transition: "transform 0.2s ease, box-shadow 0.2s ease",
              "&:hover": {
                transform: "translateY(-2px)",
                boxShadow:
                  "0 10px 24px rgba(255,65,108,0.45), 0 4px 10px rgba(0,0,0,0.12)",
                background:
                  "linear-gradient(90deg, #ff3b1b 0%, #ff2a5e 100%) !important",
              },
              "&:focus-visible": {
                outline: "3px solid #111",
                outlineOffset: "3px",
              },
            }}
            aria-label="Visit our YouTube channel"
          >
            <Link
              to={`https://www.youtube.com/channel/${process.env.REACT_APP_YOUTUBE_CHANNEL_ID}?sub_confirmation=1`}
              style={{
                color: "white",
                textDecoration: "none",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: 8,
              }}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Visit our YouTube channel (opens in a new tab)"
            >
              <span aria-hidden>▶️</span>
              <span>Visit YouTube</span>
            </Link>
          </Button>
          <Button
            size="large"
            variant="contained"
            color="primary"
            sx={{
              px: 4,
              py: 1.75,
              fontSize: "1.15rem",
              fontWeight: 700,
              letterSpacing: 0.5,
              borderRadius: 9999,
              background: "linear-gradient(90deg, #0072ff 0%, #00c6ff 100%)",
              boxShadow:
                "0 6px 18px rgba(0,114,255,0.3), 0 2px 6px rgba(0,0,0,0.1)",
              textTransform: "none",
              transition: "transform 0.2s ease, box-shadow 0.2s ease",
              "&:hover": {
                transform: "translateY(-2px)",
                boxShadow:
                  "0 10px 24px rgba(0,114,255,0.4), 0 4px 10px rgba(0,0,0,0.12)",
                background:
                  "linear-gradient(90deg, #0062e6 0%, #00b6ff 100%) !important",
              },
              "&:focus-visible": {
                outline: "3px solid #111",
                outlineOffset: "3px",
              },
            }}
            aria-label="Go to library page"
          >
            <Link
              to="/library"
              style={{
                color: "white",
                textDecoration: "none",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: 8,
              }}
              aria-label="Go to library page"
            >
              <span aria-hidden>📚</span>
              <span>Library</span>
            </Link>
          </Button>
        </Box>

        <Divider
          sx={{
            width: "100%",
          }}
        >
          {/* <Chip label="Introduction" size="small" /> */}
          <Typography variant="h4" fontWeight="bold">
            Introduction
          </Typography>
        </Divider>
        <div
          style={{
            width: "100%", // Adjust the width as needed
            marginBottom: "1rem",
          }}
        >
          <ReactPlayer
            url={IntroVideo}
            controls
            width="100%"
            height="100%"
            config={{ file: { attributes: { "aria-label": "Introduction video player" } } }}
          />
        </div>

        <Divider
          sx={{
            width: "100%",
          }}
        >
          {/* <Chip label="Our Prominent Writers" size="medium" /> */}
          <Typography variant="h4" fontWeight="bold">
            Our Prominent Writers
          </Typography>
        </Divider>
        <ImageList
          ref={imageListRef}
          sx={{ width: "100%", height: { xs: "50vh", md: "80vh" } }}
          cols={5}
          gap={8}
        >
          {images.map((path, index) => {
            const fileName = typeof path === "string" ? path : "image";
            const derivedAlt = fileName
              .split("/")
              .pop()
              ?.split(".")[0]
              .replace(/[-_]/g, " ") || `Writer ${index + 1}`;
            return (
            <ImageListItem key={index}>
              <img
                className="writer-image"
                src={path}
                alt={derivedAlt}
                loading="lazy"
                style={{ objectFit: "cover" }}
              />
            </ImageListItem>
            );
          })}
        </ImageList>
      </Stack>
    </Box>
  );
};

export default HomePage;
